"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserOpReceiptIntervals = void 0;
const core_types_1 = require("@biconomy/core-types");
// eslint-disable-next-line no-unused-vars
exports.UserOpReceiptIntervals = {
    [core_types_1.ChainId.MAINNET]: 10000,
    [core_types_1.ChainId.GOERLI]: 5000,
    [core_types_1.ChainId.POLYGON_MUMBAI]: 5000,
    [core_types_1.ChainId.POLYGON_MAINNET]: 5000,
    [core_types_1.ChainId.BSC_TESTNET]: 5000,
    [core_types_1.ChainId.BSC_MAINNET]: 5000,
    [core_types_1.ChainId.POLYGON_ZKEVM_TESTNET]: 5000,
    [core_types_1.ChainId.POLYGON_ZKEVM_MAINNET]: 5000,
    [core_types_1.ChainId.ARBITRUM_GOERLI_TESTNET]: 5000,
    [core_types_1.ChainId.ARBITRUM_ONE_MAINNET]: 5000,
    [core_types_1.ChainId.ARBITRUM_NOVA_MAINNET]: 5000,
    [core_types_1.ChainId.OPTIMISM_MAINNET]: 5000,
    [core_types_1.ChainId.OPTIMISM_GOERLI_TESTNET]: 5000,
    [core_types_1.ChainId.AVALANCHE_MAINNET]: 5000,
    [core_types_1.ChainId.AVALANCHE_TESTNET]: 5000,
    [core_types_1.ChainId.MOONBEAM_MAINNET]: 5000,
    [core_types_1.ChainId.BASE_GOERLI_TESTNET]: 5000,
    [core_types_1.ChainId.BASE_MAINNET]: 5000,
    [core_types_1.ChainId.LINEA_TESTNET]: 5000,
    [core_types_1.ChainId.MANTLE_MAINNET]: 5000,
    [core_types_1.ChainId.MANTLE_TESTNET]: 5000,
    [core_types_1.ChainId.OPBNB_MAINNET]: 5000,
    [core_types_1.ChainId.OPBNB_TESTNET]: 5000,
};
//# sourceMappingURL=Constants.js.map